import * as development from '../environments/development';
import * as fda from '../environments/fda';
import * as integration from '../environments/integration';
import * as local from '../environments/local';
import * as poc from '../environments/poc';
import * as production from '../environments/production';
import * as staging from '../environments/staging';
import * as test from '../environments/test';

const envs = {
  development,
  staging,
  production,
  fda,
  integration,
  poc,
  local,
  test,
};

export const env = process.env.VITE_ENV || 'development';

// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
const configurations = { SENTRY_ENABLED: false, ...envs[env] };
export default configurations;
